import { use, useEffect, useRef, useState } from "react";
import {
  Arrow,
  BtnSwap,
  Button,
  ButtonCloseModal,
  ButtonPaymentModal,
  ButtonSaveFileModal,
  CloseButton,
  DiscountBox,
  DocumentNoteCounter,
  DocumentNoteDesc,
  DocumentNoteFooter,
  DocumentNoteHeader,
  DocumentNoteHint,
  DocumentNoteTextarea,
  DocumentNoteTitle,
  DocumentNoteWrapper,
  FeatureContent,
  FeatureH4,
  FeatureIcon,
  FeatureItem,
  FeatureP,
  Features,
  FileActions,
  FileHeader,
  FileIcon,
  FileInfo,
  FileInfoCard,
  FileItem,
  FileName,
  FilePreview,
  FileSize,
  FormGroup,
  Hero,
  HeroDescription,
  HeroTitle,
  Label,
  LanguageRow,
  LoadingButtonContent,
  LoadingText,
  NewPrice,
  OldPrice,
  PercentText,
  PreviewButton,
  PreviewCanvas,
  PreviewContent,
  PreviewFooter,
  PreviewHeader,
  PreviewModal,
  PreviewOverlay,
  PreviewOverlayPreview,
  PreviewTitle,
  PriceTag,
  PrimaryButton,
  ProcessText,
  RadioButton,
  RemoveButton,
  SectionDescription,
  SectionHeader,
  SectionMain,
  SectionTitle,
  Select,
  SelectArrow,
  SelectWrapper,
  Spinner,
  SpinnerWrapper,
  SubProcessText,
  TabButton,
  Tabs,
  TextArea,
  UploadArea,
  UploadButton,
  WaveProgressWrapper,
  WaveTitle,
  ProcessModal,
  ProcessFileCard,
  ProcessFileExt,
  ProcessLoader,
  ProcessTip,
  FileBlock,
  UploadedFileCard,
  UploadedFileIcon,
  UploadedFileMeta,
  UploadedFileName,
  UploadedFileSize,
  UploadedFileActions,
  UploadedPreviewButton,
  UploadedDeleteButton,
  ToneSectionTitle,
  ToneListCard,
  ToneChoice,
  ToneChoiceIcon,
  ToneChoiceText,
  TermsAgreementBox,
  TermsAgreementLabel,
  TermsAgreementIcon,
  TermsText,
  TranslateNowButton,
} from "../../style/AIToolsPage_Style";
import { Note, UploadIcon, UploadSvg } from "./StyledFileTranslatePage";
import { ITokenPayload } from "../../models/user";
import { jwtDecode } from "jwt-decode";
import TranslateService from "../../services/api/translate.service";
import { toast } from "../../utils/notify";
import {
  connectSignal,
  getSignalConnection,
} from "../../services/api/signalr.Service";
import pdfjsLib from "../../pdfConfig";
import { useStore } from "../../zustand";
import PaymentService from "../../services/api/payment.service";
import { EQrcodeRequest } from "../../models/payment";
import { Helmet } from "react-helmet-async";
import SeoService from "../../services/api/seo.service";
import { ECommonPageSeo, EContentResponse } from "../../models/seo";
import FAQ from "../../components/FAQ";
import { Trans, useTranslation } from "react-i18next";
import { envConfig } from "../../config/env.config";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import ToneService from "../../services/api/tone.service";
import { ToneItem } from "../../models/tone";
import VisitService from "../../services/api/visit.service";
import { IVisitRequest } from "../../models/visit";
import { Box } from "@mui/material";

export enum EPaymentStatus {
  pending,
  success,
  translate_Processing,
  translate_Completed,
  failed,
  delete,
}

export enum EnumPdfType {
  //Full_Img = 0,
  Only_Text = 1,
  Text_Or_Image = 2,
}

export type UploadFile = {
  id: string;
  file?: File;
  fileSize?: number;
  progress: number;
  isTranslating: boolean;
  status: EPaymentStatus;
  price?: number;
  fileBase64?: string;
  previewBase64?: string;
  fileName?: string;
  orderId: string;
  numberOfTranslationServicesUsed?: number;
  totalNumberOfTranslationServicesUsed?: number;
};

export type HistoryTranslate = {
  id: string;
  fileName: string;
  fileSize: number;
  status: EPaymentStatus;
  orderId: string;
  totalCharacters: number;
  price: number;
  from: string;
  to: string;
  userId: string;
  fileDownloadBase64: string;
  filePreviewBase64: string;
  fileOriginal?: string;
  expirationDate: Date;
  createdDate: Date;
  numberOfTranslationServicesUsed?: number;
  totalNumberOfTranslationServicesUsed?: number;
  isDownload: boolean;
};

export const languages = [
  // Major
  { code: "en", label: "English" },
  { code: "vi", label: "Vietnamese" },
  { code: "zh-Hans", label: "Chinese (Simplified)" },
  { code: "zh-Hant", label: "Chinese (Traditional)" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },

  // European
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "es", label: "Spanish" },
  { code: "it", label: "Italian" },
  { code: "pt", label: "Portuguese" },
  { code: "pt-BR", label: "Portuguese (Brazil)" },
  { code: "ru", label: "Russian" },
  { code: "nl", label: "Dutch" },
  { code: "pl", label: "Polish" },
  { code: "uk", label: "Ukrainian" },
  { code: "cs", label: "Czech" },
  { code: "sk", label: "Slovak" },
  { code: "hu", label: "Hungarian" },
  { code: "ro", label: "Romanian" },
  { code: "el", label: "Greek" },
  { code: "sv", label: "Swedish" },
  { code: "no", label: "Norwegian" },
  { code: "da", label: "Danish" },
  { code: "fi", label: "Finnish" },

  // Southeast Asia
  { code: "th", label: "Thai" },
  { code: "id", label: "Indonesian" },
  { code: "ms", label: "Malay" },
  { code: "km", label: "Khmer" },
  { code: "lo", label: "Lao" },
  { code: "my", label: "Burmese" },
  { code: "fil", label: "Filipino" },

  // South Asia
  { code: "hi", label: "Hindi" },
  { code: "bn", label: "Bengali" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "ur", label: "Urdu" },
  { code: "si", label: "Sinhala" },
  { code: "ne", label: "Nepali" },

  // Middle East
  { code: "ar", label: "Arabic" },
  { code: "fa", label: "Persian (Farsi)" },
  { code: "he", label: "Hebrew" },
  { code: "tr", label: "Turkish" },

  // Africa
  { code: "sw", label: "Swahili" },
  { code: "af", label: "Afrikaans" },
  { code: "am", label: "Amharic" },
  { code: "ha", label: "Hausa" },
  { code: "yo", label: "Yoruba" },
  { code: "zu", label: "Zulu" },

  // Others
  { code: "is", label: "Icelandic" },
  { code: "ga", label: "Irish" },
  { code: "mt", label: "Maltese" },
  { code: "lb", label: "Luxembourgish" },
];

const toneStyleTypes = [
  "friendly",
  "inspiring",
  "neutral",
  "professional",
  "formal",
] as const;

const toneIcons = ["☺", "♡", "⚖", "▣", "♜"] as const;

const TERMS_STORAGE_KEY = "translate.acceptedTerms";

const getAcceptedTermsFromStorage = () => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(TERMS_STORAGE_KEY) === "1";
};

const AiToolsPage = () => {
  const { t, i18n } = useTranslation();

  const [tab, setTab] = useState<"translate" | "file" | "compress">("file");
  const [files, setFiles] = useState<UploadFile[]>([]);

  const [fromLang, setFromLang] = useState("vi");
  const [toLang, setToLang] = useState("en");
  const [isTranslating, setIsTranslating] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const signalInitedRef = useRef(false);
  const [user, setUser] = useState<ITokenPayload | null>();
  const [isDragging, setIsDragging] = useState(false);
  const [text, setText] = useState<string>();
  const [language, setLanguage] = useState<string>("VI");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [showPdfTypeModal, setShowPdfTypeModal] = useState(false);
  const [pdfType, setPdfType] = useState<EnumPdfType>(EnumPdfType.Only_Text);
  const [tones, setTone] = useState<ToneItem[]>([]);
  const [toneId, setToneId] = useState<string>();
  const [isRenderingPreview, setIsRenderingPreview] = useState(false);
  const MAX_UPLOAD_FILE_SIZE_MB = 50;
  const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;

  const [showFileSizeModal, setShowFileSizeModal] = useState(false);
  const [rejectedLargeFile, setRejectedLargeFile] = useState<File | null>(null);

  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(() =>
    getAcceptedTermsFromStorage(),
  );
  const [previewFile, setPreviewFile] = useState<UploadFile | null>(null);

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const previewRenderTokenRef = useRef(0);
  const [commonPageSeo, setCommonPageSeo] = useState<ECommonPageSeo>();

  const data = useStore((s) => s.data);

  const getDataContent = async (langParam?: string) => {
    const lang = (langParam ?? i18n.language)?.toUpperCase();
    const res = await SeoService.getCommonPageSeo("Homepage", i18n.language);
    const resTone = await ToneService.getAll(i18n.language);

    if (res.success && res.data) {
      setCommonPageSeo(res.data);
    }
    if (resTone.success) {
      setTone(resTone.data);
      setToneId(resTone.data[0]?.id);
    }

    setLanguage(lang);
  };

  const createVisit = async () => {
    const data: IVisitRequest = {
      page: "Homepage",
      userAgent: navigator.userAgent,
    };

    await VisitService.create(data);
  };

  useEffect(() => {
    getDataContent(i18n.language);
    createVisit();
  }, [i18n.language, data]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode<any>(token);

      const user: ITokenPayload = {
        ...decoded,
        isAdmin: decoded.isAdmin === true || decoded.isAdmin === "True",
      };
      setUser(user);
    } else {
      setUser(null);
    }
  }, [data]);

  const getProcessText = () => t("translate.ai_processing");

  const getFileExt = (fileName?: string) =>
    fileName ? `.${fileName.split(".").pop()?.toLowerCase()}` : "";

  const hasPdfFile = () =>
    files.some((f) => getFileExt(f.file?.name) === ".pdf");

  const handleCreate = async (selectedPdfType: EnumPdfType = pdfType) => {
    const formData = new FormData();
    formData.append("FolderName", "Translate-" + user?.fullName);
    if (files.length > 0) {
      setShowProcessModal(true); // 👈 mở modal process

      files.map((f) => {
        f.file && formData.append("Files", f.file); // 👈 thêm từng file
        formData.append("FileIds", f.id);
      });

      formData.append("From", fromLang); // 👈 thêm từng file
      formData.append("To", toLang); // 👈 thêm từng file
      toneId && formData.append("ToneId", toneId); // 👈 thêm từng file
      // Nếu là PDF thì gửi kiểu xử lý PDF xuống API.
      // Backend nhận theo enum C#: EnumPdfType { Full_Img = 0, Only_Text = 1, Text_Or_Image = 2 }
      if (hasPdfFile()) {
        formData.append("PdfType", selectedPdfType.toString());
      }

      //await UploadFileService.uploadFile(formData).then(async (response) => {
      //   if (response.success) {
      //     const data = response.data[0];

      //const path = envConfig.MEDIA_ENDPOINT + data.path;

      // const request: ITranslateRequest = {
      //   FilePath: path,
      //   FileName: data.fileName,
      //   From: fromLang,
      //   To: toLang,
      // };
      setFiles((prev) =>
        prev.map((f, i) =>
          i === 0 ? { ...f, isTranslating: true, progress: 0 } : f,
        ),
      );

      setIsTranslating(true);

      try {
        await TranslateService.create(formData);
      } catch (error) {
        toast(t("error.translate_fail"), "error");
        setShowProcessModal(false);
        setIsTranslating(false);
        setFiles((prev) =>
          prev.map((f) => ({ ...f, isTranslating: false, progress: 0 })),
        );
      }
      // toggleMessage({
      //   type: "success",
      //   message: resTranslateOfficeFile?.message ?? ""
      // });
    } else {
      toast(t("error.upload_fail"), "error");
    }
    // });
    // } else {
    //   toast("❌ Vui lòng tải lên file cần dịch", "error");
    // }
  };

  const clearPreviewContainer = () => {
    const container = document.getElementById("pdf-preview-container");
    if (container) container.innerHTML = "";
  };

  const openPreviewLoading = () => {
    previewRenderTokenRef.current += 1; // hủy render cũ nếu còn chạy
    clearPreviewContainer();
    setPreviewFile(null); // clear data modal cũ trước khi mở modal mới
    setIsRenderingPreview(true); // bật loading ngay, không chờ useEffect renderPdf
    setShowPreviewModal(true);
  };

  const closePreviewModal = () => {
    previewRenderTokenRef.current += 1; // chặn async render cũ append canvas sau khi đóng
    setShowPreviewModal(false);
    setIsRenderingPreview(false);
    setPreviewFile(null);
    setTimeout(clearPreviewContainer, 0);
  };

  useEffect(() => {
    let conn;

    const initSignalR = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;
      conn = await connectSignal(token);

      conn.on("TranslateCompleted", async (data: HistoryTranslate) => {
        setShowProcessModal(false); // 👈 đóng modal process

        setFiles((prev) =>
          prev.map((f) =>
            f.id === data.id
              ? {
                  ...f,
                  isTranslating: false,
                  progress: 100,
                  status: data.status,
                  price: data.price,
                  orderId: data.orderId,
                  previewBase64: data.filePreviewBase64,
                  fileBase64: data.fileDownloadBase64,
                  fileName: data.fileName,
                  numberOfTranslationServicesUsed:
                    data.numberOfTranslationServicesUsed,
                  totalNumberOfTranslationServicesUsed:
                    data.totalNumberOfTranslationServicesUsed,
                }
              : f,
          ),
        );

        openPreviewLoading();
        const previewRequestToken = previewRenderTokenRef.current;

        try {
          // 🔥 TỰ ĐỘNG MỞ PREVIEW MODAL
          const filePreview = await TranslateService.getFilePreview(
            data.orderId,
          );

          if (previewRequestToken !== previewRenderTokenRef.current) return;

          setPreviewFile({
            id: filePreview.data.id,
            file: new File([], filePreview.data.fileName), // dummy file
            status: filePreview.data.status,
            progress: 100,
            isTranslating: false,
            orderId: filePreview.data.orderId,
            price: filePreview.data.price,
            previewBase64: buildPreviewImageUrl(
              filePreview.data.filePreviewBase64,
            ),
            fileBase64: filePreview.data.fileDownloadBase64,
            fileName: filePreview.data.fileName,
            numberOfTranslationServicesUsed:
              filePreview.data.numberOfTranslationServicesUsed,
            totalNumberOfTranslationServicesUsed:
              filePreview.data.totalNumberOfTranslationServicesUsed,
          });
        } catch (error) {
          console.error("Preview error:", error);
          closePreviewModal();
          toast(t("error.preview_fail") || t("error.translate_fail"), "error");
        }

        setFiles([]);

        setTimeout(() => {
          //downloadBase64File(data.fileBase64, data.fileName);
          setIsTranslating(false);

          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // ✅ reset input thật sự
          }
          return;
          //}
        }, 500);
      });

      conn.on("TranslateFailed", (data) => {
        toast(t("error.translate_fail"), "error");
        setShowProcessModal(false);
        setIsTranslating(false);
        setFiles([]);
      });
    };

    initSignalR();

    return () => {
      const conn = getSignalConnection();
      conn?.off("TranslateCompleted");
      conn?.off("TranslateFailed");
    };
  }, [data]);

  useEffect(() => {
    setFiles([]);
  }, [data]);

  useEffect(() => {
    const connection = getSignalConnection();
    if (!connection) {
      console.error("❌ No SignalR connection available");
      return;
    }

    // connection.on("TranslateFailed", (data) => {
    //   toast(t("error.translate_fail"), "error");
    //   setShowProcessModal(false);
    //   setIsTranslating(false);
    //   setFiles([]);
    // });
  }, []);

  const formatFileSizeMB = (size: number) => {
    return `${(size / 1024 / 1024).toFixed(2)} MB`;
  };

  const base64ToUrl = (base64: string) => {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) u8arr[n] = bstr.charCodeAt(n);

    const blob = new Blob([u8arr], { type: mime });
    return URL.createObjectURL(blob);
  };

  const handlePreviewFileModal = (uploadFile: UploadFile) => {
    openPreviewLoading();
    const previewRequestToken = previewRenderTokenRef.current;

    requestAnimationFrame(() => {
      if (previewRequestToken !== previewRenderTokenRef.current) return;
      setPreviewFile(uploadFile);
    });
  };

  const handleSwapLanguage = () => {
    setFromLang((prevFrom) => {
      setToLang(prevFrom);
      return toLang;
    });
  };

  const handleAddFile = (file: File) => {
    if (!user) return toast(t("auth.login_required"), "info");

    const allowExt = [".doc", ".docx", ".pptx", ".xlsx", ".pdf"];
    const ext = "." + file.name.split(".").pop()?.toLowerCase();

    if (!allowExt.includes(ext)) {
      toast(t("error.unsupported_format"), "error");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return;
    }

    if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      setRejectedLargeFile(file);
      setShowFileSizeModal(true);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return;
    }

    setFiles([
      {
        id: crypto.randomUUID(),
        file,
        status: EPaymentStatus.pending,
        progress: 0,
        isTranslating: false,
        orderId: "",
      },
    ]);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    if (files.length > 0) return;
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);

    if (files.length > 0) return;

    const file = e.dataTransfer.files?.[0];
    if (!file) return;

    handleAddFile(file);
  };

  const handleGetQrcode = async () => {
    if (previewFile) {
      const data: EQrcodeRequest = {
        orderId: previewFile.orderId,
        price: previewFile.price ?? 0,
      };

      const qrcode = await PaymentService.GetQrCode(data);

      if (qrcode.success) {
        window.open(qrcode.data, "_blank");
      } else {
        toast(t("error.qr_fail"), "error");
      }
    } else {
      toast(t("error.qr_fail"), "error");
    }
  };

  const handleAcceptedTermsChange = (checked: boolean) => {
    setAcceptedTerms(checked);

    if (checked) {
      localStorage.setItem(TERMS_STORAGE_KEY, "1");
    } else {
      localStorage.removeItem(TERMS_STORAGE_KEY);
    }
  };

  const formatVND = (value: number): string => {
    return new Intl.NumberFormat("vi-VN").format(value);
  };

  const createOrder = async (customOrderId?: string | null, price?: number) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "paypal_click",
    });

    const res = await fetch(
      envConfig.API_ENDPOINT +
        `/paypal/create-order?customOrderId=${customOrderId}&price=${price}`,
      {
        method: "POST",
      },
    );

    if (!res.ok) {
      toast("Tạo thanh toán thất bại", "error");
      return;
    }

    const data = await res.json();
    return data.id;
  };

  const onApprove = async (data: any, customOrderId?: string) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "purchase",
      transaction_id: data.orderID,
      value: data.price,
      currency: "USD",
      payment_method: "paypal",
      custom_order_id: customOrderId,
    });

    await fetch(
      envConfig.API_ENDPOINT +
        `/paypal/capture-order?orderId=${data.orderID}&customOrderId=${customOrderId}`,
      { method: "POST" },
    );

    toast("Thanh toán PayPal thành công", "success");

    setShowPaymentModal(false);

    // cập nhật trạng thái file đã thanh toán
    setFiles((prev) =>
      prev.map((f) =>
        f.id === previewFile?.id ? { ...f, status: EPaymentStatus.success } : f,
      ),
    );

    envConfig.KEY_BASE === "vn"
      ? window.open(
          "https://docme.vn/transaction?orderId=" + customOrderId,
          "_blank",
        )
      : window.open(
          "https://docme.world/transaction?orderId=" + customOrderId,
          "_blank",
        );
  };

  const validTones = (tones || []).filter((t) => t && t.id && t.question);

  const processFile = files.find((f) => f.isTranslating) || files[0];

  const processFileName =
    processFile?.file?.name || processFile?.fileName || "Document";

  const processFileSize = processFile?.file?.size
    ? `${(processFile.file.size / 1024 / 1024).toFixed(2)} MB`
    : "";

  const processFileExt =
    processFileName.split(".").pop()?.toUpperCase() || "FILE";

  const pdfTypeOptions = [
    {
      value: EnumPdfType.Only_Text,
      title: t("pdf.only_text.title"),
      desc: t("pdf.only_text.desc"),
    },
    {
      value: EnumPdfType.Text_Or_Image,
      title: t("pdf.text_or_image.title"),
      desc: t("pdf.text_or_image.desc"),
    },
    // {
    //   value: EnumPdfType.Full_Img,
    //   title: t("pdf.full_image.title"),
    //   desc: t("pdf.full_image.desc"),
    // },
  ];

  const handleTranslateClick = () => {
    if (!user) return toast(t("auth.login_required"), "info");
    if (!files.length) return toast(t("error.upload_fail"), "error");

    if (hasPdfFile()) {
      setPdfType(EnumPdfType.Only_Text);
      setShowPdfTypeModal(true);
      return;
    }

    handleCreate();
  };

  const buildPreviewImageUrl = (path?: string) => {
    if (!path) return "";

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const baseUrl = envConfig.API_ENDPOINT.replace(/\/api\/?$/i, "").replace(
      /\/$/g,
      "",
    );

    const cleanPath = path.startsWith("/") ? path : `/${path}`;

    return encodeURI(`${baseUrl}${cleanPath}`);
  };

  return (
    <>
      <Helmet>
        {/* ===== BASIC SEO ===== */}
        <title>
          {commonPageSeo?.page?.title || "Dịch tài liệu online | MikoTech"}
        </title>

        <meta
          name="description"
          content={
            commonPageSeo?.seo?.description ||
            "Dịch tài liệu online nhanh, chính xác, bảo mật. Hỗ trợ PDF, Word, Excel, PPT, hình ảnh."
          }
        />

        <meta
          name="keywords"
          content={
            commonPageSeo?.seo?.keywords ||
            "dịch tài liệu, dịch file pdf, dịch tiếng anh"
          }
        />

        {/* <link rel="icon" href="/logo/Logo-D-docme.vn-2026.png" /> */}

        <meta name="author" content={commonPageSeo?.seo?.author} />
        {/* <meta name="robots" content="index, follow" /> */}
        <meta
          name="robots"
          content={
            commonPageSeo?.seo?.noIndex ? "noindex, nofollow" : "index, follow"
          }
        />
        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href={
            commonPageSeo?.seo?.canonical
              ? commonPageSeo?.seo?.canonical
              : "https://docme.vn" + commonPageSeo?.page.url
          }
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta property="og:type" content={commonPageSeo?.seo?.og_type} />
        <meta
          property="og:site_name"
          content={commonPageSeo?.seo?.og_site_name}
        />
        <meta property="og:title" content={commonPageSeo?.seo?.og_title} />
        <meta
          property="og:description"
          content={commonPageSeo?.seo?.og_description}
        />
        <meta
          property="og:url"
          content={commonPageSeo?.seo?.og_url || "https://docme.vn/"}
        />
        <meta property="og:image" content={commonPageSeo?.seo?.og_image_alt} />
        <meta
          property="og:image:width"
          content={commonPageSeo?.seo?.og_image_width}
        />
        <meta
          property="og:image:height"
          content={commonPageSeo?.seo?.og_image_height}
        />
        <meta property="og:locale" content={commonPageSeo?.seo?.og_locale} />

        <meta name="twitter:card" content={commonPageSeo?.seo?.twitter_card} />
        <meta
          name="twitter:title"
          content={commonPageSeo?.seo?.twitter_title}
        />
        <meta
          name="twitter:description"
          content={commonPageSeo?.seo?.twitter_description}
        />
        <meta
          name="twitter:image"
          content={commonPageSeo?.seo?.twitter_image}
        />

        {/* ===== CONTACT / BUSINESS INFO ===== */}
        {commonPageSeo?.seo?.schema && (
          <div
            dangerouslySetInnerHTML={{ __html: commonPageSeo?.seo?.schema }}
          />
        )}
      </Helmet>

      <Hero>
        <HeroTitle>{t("hero.title")}</HeroTitle>
        <HeroDescription>{t("hero.description")}</HeroDescription>
      </Hero>

      {/* TABS */}
      {/* <div style={{ textAlign: "center" }}>
        <Tabs>
          <TabButton
            active={tab === "translate"}
            onClick={() => setTab("translate")}>
            Dịch ngôn ngữ
          </TabButton>
          <TabButton active={tab === "file"} onClick={() => setTab("file")}>
            <svg
              width={24}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            {t("tabs.translate")}
          </TabButton>
          <TabButton
          //active={tab === "compress"}
          //onClick={() => setTab("compress")}
          >
            {t("tabs.compress")}
          </TabButton>
        </Tabs>
      </div> */}

      {/* {tab === "translate" && (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 24,
              marginTop: 32,
            }}>
            <TextArea
              placeholder="Nhập văn bản cần dịch..."
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <TextArea readOnly placeholder="Bản dịch..." />
          </div>
        </>
      )} */}
      <Box
        sx={{
          display: user ? "block" : "none",
          mt: 1.5,
          p: 1.5,
          border: "1px solid #f8d4d4",
          background: "#fef2f2",
          borderRadius: "12px",
          color: "#000000",
          fontSize: "15px",
          lineHeight: 1.5,
        }}>
        <b>
          <i>
            {t("note.review_note_before")}{" "}
            <span style={{ color: "red" }}>
              {Math.max(
                (commonPageSeo?.seo?.totalNumberOfTranslationServicesUsed ??
                  0) -
                  (commonPageSeo?.seo?.numberOfTranslationServicesUsed ?? 0),
                0,
              )}{" "}
            </span>
            {t("note.review_note_after")}
          </i>
        </b>
      </Box>

      <SectionMain>
        {tab === "file" && (
          <>
            <SectionHeader>
              <SectionTitle>{t("file.section_title")}</SectionTitle>
              <SectionDescription>
                {t("file.section_description")}
              </SectionDescription>
            </SectionHeader>

            <FormGroup>
              <LanguageRow>
                <Label>{t("file.from_language")}</Label>

                <SelectWrapper>
                  <Select
                    value={fromLang}
                    onChange={(e) => setFromLang(e.target.value)}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = "none";
                      e.currentTarget.style.boxShadow = "none";
                    }}>
                    {languages.map((l) => (
                      <option key={l.code} value={l.code}>
                        {l.label}
                      </option>
                    ))}
                  </Select>

                  <SelectArrow>
                    <svg width="20" height="20" viewBox="0 0 24 24">
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </SelectArrow>
                </SelectWrapper>
              </LanguageRow>

              <BtnSwap onClick={handleSwapLanguage}>
                <svg
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"></path>
                </svg>
              </BtnSwap>

              <LanguageRow>
                <Label>{t("file.to_language")}</Label>
                <SelectWrapper>
                  <Select
                    value={toLang}
                    onChange={(e) => setToLang(e.target.value)}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = "none";
                      e.currentTarget.style.boxShadow = "none";
                    }}>
                    {languages.map((l) => (
                      <option key={l.code} value={l.code}>
                        {l.label}
                      </option>
                    ))}
                  </Select>

                  <SelectArrow>
                    <svg width="20" height="20" viewBox="0 0 24 24">
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </SelectArrow>
                </SelectWrapper>
              </LanguageRow>
            </FormGroup>

            <UploadArea
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              style={{
                border: isDragging
                  ? "2px dashed #2563eb"
                  : "2px dashed #e5e7eb",
                backgroundColor: isDragging ? "#eff6ff" : "#ffffff",
                transition: "all 0.2s ease",
              }}>
              <UploadIcon>
                <UploadSvg
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                </UploadSvg>
              </UploadIcon>
              <FeatureP style={{ fontSize: 18, fontWeight: 500 }}>
                {t("file.drag_text")}{" "}
              </FeatureP>
              <UploadButton isDisabled={files.length > 0}>
                <img
                  style={{ filter: "invert(1)" }}
                  width={"20px"}
                  src="/icon/1091554.png"
                />
                {t("file.choose_file")}
                <input
                  ref={fileInputRef} // 👈 THÊM DÒNG NÀY
                  disabled={files.length > 0}
                  type="file"
                  hidden
                  accept=".doc,.docx,.xlsx,.pptx,.pdf"
                  onChange={(e) => {
                    const file = e.target.files?.[0];

                    if (!file) return;

                    handleAddFile(file);
                  }}
                />
              </UploadButton>
              <p
                style={{
                  marginTop: 12,
                  fontSize: 14,
                  color: "#6b7280",
                  marginBottom: 0,
                }}>
                {t("file.support_text")}
              </p>
              <p
                style={{
                  marginTop: 5,
                  fontSize: 14,
                  color: "red",
                  marginBottom: 0,
                }}>
                {t("fileSizeModal.descAfter")}{" "}
                <b>{MAX_UPLOAD_FILE_SIZE_MB} MB</b>.
              </p>

              {/* {files &&
                files.map((f) => {
                  return <FilePreview>{f.file.name}</FilePreview>;
                })} */}
            </UploadArea>

            {files.map((f, i) => {
              const fileName = f.file?.name || f.fileName || "Document";
              const fileSizeText = f.file?.size
                ? `${(f.file.size / 1024 / 1024).toFixed(2)} MB`
                : f.fileSize
                  ? `${(f.fileSize / 1024 / 1024).toFixed(2)} MB`
                  : "";
              const fileExtLabel =
                fileName.split(".").pop()?.toUpperCase().slice(0, 4) || "FILE";

              return (
                <FileBlock key={f.id || i}>
                  <UploadedFileCard>
                    <UploadedFileIcon>
                      <span>{fileExtLabel}</span>
                    </UploadedFileIcon>

                    <UploadedFileMeta>
                      <UploadedFileName title={fileName}>
                        {fileName}
                      </UploadedFileName>
                      {fileSizeText && (
                        <UploadedFileSize>- {fileSizeText}</UploadedFileSize>
                      )}
                    </UploadedFileMeta>

                    <UploadedFileActions>
                      {f.previewBase64 && (
                        <UploadedPreviewButton
                          type="button"
                          onClick={() => handlePreviewFileModal(f)}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round">
                            <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                          Preview
                        </UploadedPreviewButton>
                      )}

                      <UploadedDeleteButton
                        type="button"
                        onClick={() => {
                          setFiles((prev) =>
                            prev.filter((_, idx) => idx !== i),
                          );

                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                          }
                        }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16">
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                        {t("common.delete")}
                      </UploadedDeleteButton>
                    </UploadedFileActions>
                  </UploadedFileCard>

                  {validTones.length > 0 && (
                    <>
                      <ToneSectionTitle>
                        {t("translate.selectTone")}
                      </ToneSectionTitle>

                      <ToneListCard>
                        {validTones.map((l, index) => {
                          const isChecked =
                            toneId === l.id || (!toneId && index === 0);
                          const toneType =
                            toneStyleTypes[index % toneStyleTypes.length];

                          return (
                            <ToneChoice
                              key={l.id}
                              htmlFor={`tone-${l.id}`}
                              selected={isChecked}>
                              <input
                                type="radio"
                                id={`tone-${l.id}`}
                                name="tone"
                                value={l.id}
                                checked={isChecked}
                                onChange={() => setToneId(l.id)}
                              />
                              <span className="radio-dot" />
                              <ToneChoiceIcon className={`tone-${toneType}`}>
                                {toneIcons[index % toneIcons.length]}
                              </ToneChoiceIcon>
                              <ToneChoiceText>{l.question}</ToneChoiceText>
                            </ToneChoice>
                          );
                        })}
                      </ToneListCard>
                    </>
                  )}

                  {showProcessModal && processFile && (
                    <PreviewOverlay
                      style={{
                        background: "rgba(15, 23, 42, 0.62)",
                        backdropFilter: "blur(8px)",
                      }}>
                      <ProcessModal>
                        <PreviewHeader
                          style={{
                            borderBottom: "none",
                            paddingBottom: 0,
                            justifyContent: "center",
                          }}>
                          <PreviewTitle
                            style={{
                              textAlign: "center",
                              fontSize: 20,
                              fontWeight: 800,
                            }}>
                            {t("file.translating_short")}
                          </PreviewTitle>
                        </PreviewHeader>

                        <PreviewContent
                          style={{
                            marginTop: 18,
                            padding: 0,
                            background: "transparent",
                            maxHeight: "unset",
                            overflow: "visible",
                            textAlign: "center",
                          }}>
                          <ProcessFileCard>
                            <ProcessFileExt>{processFileExt}</ProcessFileExt>

                            <div style={{ minWidth: 0, textAlign: "left" }}>
                              <FileName style={{ maxWidth: 330 }}>
                                {processFileName}
                              </FileName>

                              <FileSize>
                                {processFileSize}
                                {processFileSize ? " · " : ""}
                                Đang xử lý
                              </FileSize>
                            </div>
                          </ProcessFileCard>

                          <ProcessLoader aria-hidden="true">
                            <span />
                            <span />
                            <span />
                            <i />
                          </ProcessLoader>

                          <ProcessText>{getProcessText()}</ProcessText>

                          <ProcessTip>
                            {t("translation.keepThisPageOpen")}
                          </ProcessTip>
                        </PreviewContent>
                      </ProcessModal>
                    </PreviewOverlay>
                  )}
                </FileBlock>
              );
            })}

            {files.length > 0 && (
              <TermsAgreementBox accepted={acceptedTerms}>
                <TermsAgreementLabel>
                  <TermsAgreementIcon>
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
                      <path d="m9 12 2 2 4-5" />
                    </svg>
                  </TermsAgreementIcon>

                  <input
                    type="checkbox"
                    checked={acceptedTerms}
                    onChange={(e) =>
                      handleAcceptedTermsChange(e.target.checked)
                    }
                  />

                  <TermsText>
                    <Trans
                      i18nKey="translate.terms"
                      components={{
                        termsLink: (
                          <a
                            href={
                              envConfig.KEY_BASE === "vn"
                                ? "https://docme.vn/chinh-sach-dieu-khoan-su-dung"
                                : "https://docme.world/policies-terms-of-use"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          />
                        ),
                      }}
                    />
                  </TermsText>
                </TermsAgreementLabel>
              </TermsAgreementBox>
            )}

            <div
              style={{
                textAlign: "center",
                marginTop: 24,
                marginBottom: "24px",
              }}>
              <TranslateNowButton
                type="button"
                onClick={handleTranslateClick}
                disabled={
                  !user || isTranslating || !files.length || !acceptedTerms
                }>
                {isTranslating ? (
                  <LoadingButtonContent>
                    <Spinner />
                    <LoadingText>{t("file.translating")}</LoadingText>
                  </LoadingButtonContent>
                ) : (
                  <>
                    <img
                      style={{ filter: "invert(1)" }}
                      width={"20px"}
                      src="/icon/ai-file_9812085.png"
                    />{" "}
                    {t("file.translate_now")}
                  </>
                )}
              </TranslateNowButton>
              {/* <TranslateNowButton disabled={!files.length}>Dịch file</TranslateNowButton> */}
            </div>

            <Note>
              {t("note.line1")}
              <br />
              {t("note.line2")}
              <br />
              {t("note.line3")}
              <br />
              {t("note.line4")}
              <br />
              {t("note.line5")}
              <br />
              <p style={{ marginTop: "1rem", fontSize: "13px" }}>
                <i style={{ color: "red" }}>{t("note.warning")}</i>
              </p>
            </Note>

            {/* {isTranslating &&
              files.length > 0 &&
              files.map((f) => {
                return (
                  <WaveProgressWrapper>
                    <WaveTitle>
                      📄 Đang dịch: <b>{f.file.name}</b>
                    </WaveTitle>

                    <WaveProgress>
                      <WaveProgressFill
                        style={{ width: `${progress}%` }}
                        done={progress === 100}
                      />
                    </WaveProgress>

                    <WavePercent>{progress}%</WavePercent>
                  </WaveProgressWrapper>
                );
              })} */}

            {/* {previewBase64 && (
              <div style={{ marginTop: 24 }}>
                <Button onClick={() => setShowPreviewModal(true)}>
                  👁 Preview
                </Button>
              </div>
            )} */}

            {showPreviewModal && (
              <PreviewOverlayPreview>
                <PreviewModal>
                  <PreviewHeader>
                    <PreviewTitle>{t("preview.title")}</PreviewTitle>
                    <CloseButton onClick={closePreviewModal}>✕</CloseButton>
                  </PreviewHeader>

                  <Box sx={{ paddingTop: "10px", fontSize: "15px" }}>
                    <b>
                      <i>
                        {t("note.review_note_before")}{" "}
                        <span style={{ color: "red" }}>
                          {Math.max(
                            (previewFile?.totalNumberOfTranslationServicesUsed ??
                              0) -
                              (previewFile?.numberOfTranslationServicesUsed ??
                                0),
                            0,
                          )}{" "}
                        </span>
                        {t("note.review_note_after")}
                      </i>{" "}
                    </b>
                  </Box>

                  <PreviewContent
                    style={{
                      position: "relative",
                      minHeight: 500,
                    }}>
                    {isRenderingPreview && (
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "rgba(255,255,255,.92)",
                          backdropFilter: "blur(6px)",
                          zIndex: 999,
                          gap: 24,
                        }}>
                        <div
                          style={{
                            width: 70,
                            height: 70,
                            borderRadius: "50%",
                            border: "5px solid #dbeafe",
                            borderTop: "5px solid #2563eb",
                            animation: "spin 1s linear infinite",
                          }}
                        />

                        <div
                          style={{
                            width: 260,
                            height: 6,
                            background: "#e5e7eb",
                            borderRadius: 999,
                            overflow: "hidden",
                          }}>
                          <div
                            style={{
                              width: "40%",
                              height: "100%",
                              borderRadius: 999,
                              background:
                                "linear-gradient(90deg,#2563eb,#60a5fa,#2563eb)",
                              animation: "loadingBar 1.2s infinite ease-in-out",
                            }}
                          />
                        </div>

                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 600,
                            color: "#1e3a8a",
                          }}>
                          {t("preview.loading_title")}
                          <span className="loading-dots">...</span>
                        </div>

                        <div
                          style={{
                            color: "#6b7280",
                            fontSize: 14,
                          }}>
                          {t("preview.loading_desc")}
                        </div>
                      </div>
                    )}

                    <div id="pdf-preview-container">
                      {previewFile?.previewBase64 && (
                        <img
                          src={previewFile.previewBase64}
                          alt={previewFile.fileName || "Preview"}
                          onLoad={() => setIsRenderingPreview(false)}
                          onError={() => {
                            setIsRenderingPreview(false);
                            toast(
                              t("error.preview_fail") ||
                                t("error.translate_fail"),
                              "error",
                            );
                          }}
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                            borderRadius: 12,
                            background: "#ffffff",
                          }}
                        />
                      )}
                    </div>
                  </PreviewContent>

                  <PreviewFooter>
                    <i className="footer-item-i">
                      <img
                        style={{
                          filter:
                            "invert(17%) sepia(96%) saturate(7492%) hue-rotate(358deg) brightness(95%) contrast(112%)",
                        }}
                        width={30}
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADLUlEQVR4nO2YW4hNURjHf2MuucygiJmU5JIXFMIULxMPGl7IpcjgxVAYl7yIBxQKD3gYPLhElIRccsklNSGM3MaDW8gYd7mEGWO2Vv67lm3O6Zyz9z7nqP2r1Tn722t93/r2+tZa31oQERERERERERhtgErgNtAIOCGXJqAOWAzkBecG7ElD550Y5USqzhQBm4DHwFPgghR+BSqAQsKnEJgNfJHtpckqGAA8iPFl5pJ+Zsr2/WQajQI+qOEtYDBQAjRLZkYq3bSX7Z+JVM7R0DWp0XEpcHGypMSlizpuKrYAm1uZWFnvyHDgiSp9AqbEqJe1juQAVVYoXQd6x3E4Kx0pAc5aobQRyI83bInGaIg4XvvjgTcSvtVzSorSjOPabwts1QgYwRmNTNKK4pALlAFbFKr3gJ1AP38+/G3/pv58BxZpjhCQI/nagWNtombk+yRpL6b9Bm1wA0mN1hwpUkL3zHpvUprVQKlG4ojk+1K0+4/9fGWvBOBIMbDWygAcZakzWtl/+uq9qesHJ6g56iraAfywni8B4+KEamfVawrIvi+GeWL+F3AIGJFA2wq1uZNJR3KAY5aSb0C1wiURzAR/obYLyaAjecAr4D2wBuiWRNuRQL2MXwnghOf4Da0OQEES9XvqJOnuV9eArn46wJ+P4IZ06AwBdlm5m/ldB7QLQHepdJplPjTGArXW0Ddrz+gfgO5cLSh10r2BkJhsjUDY5S7QMQwnpuvoGWbnW4DnugTpFIYTlZp4xtgqYJb+H/DUq5Z8gecg5ygvyxgmxVlurUhmSTas0PN6T/2TkpdbsiWSmQ017ZgjwCTgqrUMmtOly37J53na1Ug+2lpGTaw7ypZ9dai7stKhwBhgopSajq3UyrAdOAic0vWody5clL4CJY+u3CSNNuesThu72/Rc72dZvuxj0jWq81W6aTSyl8BnT729SmtMmW+FoONJc8r8jEaNOmSOuY+AG8B54DCwW1dAJuaXAXOAqToGD9JIukwD3lmrSq1uAl0HG3TF6r4/DbwGPgJHpS9rMBtVL6XoLuX6QO6XfwhM4D+mGOjh8xAXERERERERQRx+A1Ns/jikzsHQAAAAAElFTkSuQmCC"
                        alt="card-in-use"></img>{" "}
                      {t("preview.note")}
                    </i>

                    <div className="footer-item-div">
                      <ButtonPaymentModal
                        className="ButtonPayment"
                        onClick={() => setShowPaymentModal(true)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          strokeWidth="0.8"
                          className="bi bi-credit-card"
                          viewBox="0 0 16 16">
                          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                          <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
                        </svg>
                        {t("preview.payment")}{" "}
                        {envConfig.KEY_BASE === "vn"
                          ? previewFile?.price &&
                            formatVND(previewFile?.price) + " VNĐ"
                          : previewFile?.price && previewFile?.price + " $"}
                      </ButtonPaymentModal>

                      {/* {user?.isAdmin === true && (
                        <ButtonSaveFileModal
                          onClick={
                            () =>
                              // previewFile?.status === EPaymentStatus.success
                              previewFile?.fileBase64 &&
                              downloadBase64File(
                                previewFile.fileBase64,
                                previewFile.file
                                  ? (previewFile.fileName ??
                                      previewFile.file.name)
                                  : "",
                              )
                            
                          }>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="0.8"
                            className="bi bi-download">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                          </svg>
                          {t("preview.download")}
                        </ButtonSaveFileModal>
                      )} */}

                      <ButtonCloseModal onClick={closePreviewModal}>
                        {t("common.close")}
                      </ButtonCloseModal>
                    </div>
                  </PreviewFooter>
                </PreviewModal>
              </PreviewOverlayPreview>
            )}

            {showPaymentModal && (
              <PreviewOverlay>
                <PreviewModal style={{ maxWidth: 420 }}>
                  <PreviewHeader>
                    <PreviewTitle>
                      {t("preview.choose_payment_method")}
                    </PreviewTitle>
                    <CloseButton onClick={() => setShowPaymentModal(false)}>
                      ✕
                    </CloseButton>
                  </PreviewHeader>

                  <PreviewContent
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 16,
                      padding: 20,
                    }}>
                    {envConfig.KEY_BASE === "vn" ? (
                      <>
                        {/* VietQR */}
                        <ButtonPaymentModal
                          className="ButtonVnpayPayment"
                          sx={{ justifyContent: "center" }}
                          onClick={() => {
                            setShowPaymentModal(false);
                            handleGetQrcode();
                          }}>
                          <img
                            style={{
                              height: "20px",
                              filter: "drop-shadow(0px 1px 1px white)",
                            }}
                            src="/icon/VietQR.46a78cbb.png"
                          />{" "}
                          🇻🇳 VietQR
                        </ButtonPaymentModal>
                      </>
                    ) : (
                      <>
                        {/* PayPal */}
                        <div
                          style={{ marginTop: 10 }}
                          className="ButtonPayPalPayment">
                          <PayPalButtons
                            style={{ layout: "vertical" }}
                            createOrder={() =>
                              createOrder(
                                previewFile?.orderId,
                                previewFile?.price,
                              )
                            }
                            onApprove={(data) =>
                              onApprove(data, previewFile?.orderId)
                            }
                          />
                        </div>
                      </>
                    )}
                  </PreviewContent>
                </PreviewModal>
              </PreviewOverlay>
            )}

            {showPdfTypeModal && (
              <PreviewOverlay>
                <PreviewModal style={{ maxWidth: 520 }}>
                  <PreviewHeader>
                    <PreviewTitle>
                      {t("pdf.selectPdfTranslationMode")}
                    </PreviewTitle>
                    <CloseButton onClick={() => setShowPdfTypeModal(false)}>
                      ✕
                    </CloseButton>
                  </PreviewHeader>

                  <PreviewContent
                    style={{
                      background: "#ffffff",
                      display: "flex",
                      flexDirection: "column",
                      gap: 14,
                      padding: 20,
                    }}>
                    <div style={{ fontSize: 14, color: "#4b5563" }}>
                      {t("pdf.selectPdfProcessingModeBeforeStart")}{" "}
                    </div>

                    {pdfTypeOptions.map((option) => (
                      <RadioButton
                        key={option.value}
                        onClick={() => setPdfType(option.value)}
                        style={{
                          alignItems: "center",
                          padding: "12px",
                          border:
                            pdfType === option.value
                              ? "1px solid #2563eb"
                              : "1px solid #e5e7eb",
                          borderRadius: 10,
                          background:
                            pdfType === option.value ? "#eff6ff" : "#ffffff",
                          cursor: "pointer",
                        }}>
                        <input
                          type="radio"
                          id={`pdf-type-${option.value}`}
                          name="pdfType"
                          value={option.value}
                          checked={pdfType === option.value}
                          onChange={() => setPdfType(option.value)}
                        />

                        <label htmlFor={`pdf-type-${option.value}`}></label>

                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                            cursor: "pointer",
                            flex: 1,
                            fontSize: 14,
                            color: "#334155",
                          }}>
                          <b style={{ color: "#111827" }}>{option.title}</b>
                          <small style={{ color: "red", lineHeight: 1.4 }}>
                            {option.desc}
                          </small>
                        </span>
                      </RadioButton>
                    ))}
                  </PreviewContent>

                  <PreviewFooter
                    style={{ justifyContent: "center", alignItems: "center" }}>
                    <div style={{ display: "flex", gap: 8 }}>
                      <ButtonPaymentModal
                        onClick={() => {
                          setShowPdfTypeModal(false);
                          handleCreate(pdfType);
                        }}
                        disabled={isTranslating}>
                        {t("common.ok")}
                      </ButtonPaymentModal>

                      <ButtonCloseModal
                        onClick={() => setShowPdfTypeModal(false)}
                        disabled={isTranslating}>
                        {t("common.close")}
                      </ButtonCloseModal>
                    </div>
                  </PreviewFooter>
                </PreviewModal>
              </PreviewOverlay>
            )}
          </>
        )}

        {showFileSizeModal && (
          <PreviewOverlay>
            <PreviewModal style={{ maxWidth: 460 }}>
              <PreviewHeader>
                <PreviewTitle>{t("fileSizeModal.title")}</PreviewTitle>

                <CloseButton
                  onClick={() => {
                    setShowFileSizeModal(false);
                    setRejectedLargeFile(null);
                  }}>
                  ✕
                </CloseButton>
              </PreviewHeader>

              <PreviewContent
                style={{
                  background: "#ffffff",
                  padding: 24,
                  textAlign: "center",
                }}>
                <div
                  style={{
                    width: 72,
                    height: 72,
                    margin: "0 auto 16px",
                    borderRadius: "50%",
                    background: "#fef2f2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#dc2626",
                  }}>
                  <svg
                    width="38"
                    height="38"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
                  </svg>
                </div>

                <div
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    color: "#111827",
                    marginBottom: 8,
                  }}>
                  {t("fileSizeModal.heading")}
                </div>

                <div
                  style={{
                    color: "#4b5563",
                    fontSize: 15,
                    lineHeight: 1.6,
                  }}>
                  {t("fileSizeModal.descBefore")}{" "}
                  <b style={{ color: "#dc2626" }}>
                    {rejectedLargeFile
                      ? formatFileSizeMB(rejectedLargeFile.size)
                      : ""}
                  </b>
                  . {t("fileSizeModal.descAfter")}{" "}
                  <b>{MAX_UPLOAD_FILE_SIZE_MB} MB</b>.
                </div>

                {rejectedLargeFile?.name && (
                  <div
                    style={{
                      marginTop: 14,
                      padding: "10px 12px",
                      borderRadius: 10,
                      background: "#f9fafb",
                      border: "1px solid #e5e7eb",
                      color: "#374151",
                      fontSize: 14,
                      wordBreak: "break-word",
                    }}>
                    {rejectedLargeFile.name}
                  </div>
                )}
              </PreviewContent>

              <PreviewFooter style={{ justifyContent: "center" }}>
                <ButtonCloseModal
                  onClick={() => {
                    setShowFileSizeModal(false);
                    setRejectedLargeFile(null);
                  }}>
                  {t("fileSizeModal.confirm")}
                </ButtonCloseModal>
              </PreviewFooter>
            </PreviewModal>
          </PreviewOverlay>
        )}

        <Features>
          <FeatureItem>
            <FeatureIcon>📄</FeatureIcon>
            <FeatureContent>
              <FeatureH4>{t("feature.format.title")}</FeatureH4>
              <FeatureP>{t("feature.format.desc")}</FeatureP>
            </FeatureContent>
          </FeatureItem>

          <FeatureItem>
            <FeatureIcon>🔒</FeatureIcon>
            <FeatureContent>
              <FeatureH4>{t("feature.security.title")}</FeatureH4>
              <FeatureP>{t("feature.security.desc")}</FeatureP>
            </FeatureContent>
          </FeatureItem>

          <FeatureItem>
            <FeatureIcon>✨</FeatureIcon>
            <FeatureContent>
              <FeatureH4>{t("feature.layout.title")}</FeatureH4>
              <FeatureP>{t("feature.layout.desc")}</FeatureP>
            </FeatureContent>
          </FeatureItem>
        </Features>
      </SectionMain>

      <DocumentNoteWrapper
        dangerouslySetInnerHTML={{
          __html:
            i18n.language === "VI"
              ? commonPageSeo?.seo?.content
                ? commonPageSeo?.seo?.content.replace(/&nbsp;/g, " ")
                : ""
              : i18n.language === "EN"
                ? commonPageSeo?.seo?.content_en
                  ? commonPageSeo?.seo?.content_en.replace(/&nbsp;/g, " ")
                  : ""
                : i18n.language === "ID"
                  ? commonPageSeo?.seo?.content_indo
                    ? commonPageSeo?.seo?.content_indo.replace(/&nbsp;/g, " ")
                    : ""
                  : i18n.language === "TH"
                    ? commonPageSeo?.seo?.content_th
                      ? commonPageSeo?.seo?.content_th.replace(/&nbsp;/g, " ")
                      : ""
                    : "",
        }}
      />
      {/* 
      {commonPageSeo?.faqs && commonPageSeo?.faqs.length > 0 && (
        <FAQ faqs={commonPageSeo?.faqs} />
      )} */}
    </>
  );
};

export default AiToolsPage;
